<template>
    <client-only>
        <portal to="limb" ref="portal">
            <transition name="overlay">
                <div class="overlay"
                    :class="classes"
                    v-if="shown"
                    id="cases-overlay"
                >
                    <button
                        v-if="!hideClose"
                        @click.prevent="close"
                        title="Вихід (ESC)"
                        class="btn-close"
                    >
                        <span class="icon-ic-dismiss"></span>
                    </button>

                    <slot/>
                </div>
            </transition>
        </portal>
    </client-only>
</template>

<script>
export default {
    props: ['name', 'hideClose', 'classes'],

    data () {
        return {
            bodyClassName: 'overlay-open'
        }
    },

    computed: {
        shown () {
            return this.$modalityStore.overlay == this.name;
        }
    },

    watch: {
        shown (newVal) {
            if (newVal) {
                this.$cropContent();

                requestAnimationFrame(() => {
                    document.body.classList.add('push-content');
                    
                    // Wait for class push-content apply
                    requestAnimationFrame(() => {
                        if (this.shown) {
                            document.body.classList.add(this.bodyClassName);
                        }
                    });
                });
            }
            else {
                document.body.classList.remove(this.bodyClassName);

                // To DO better timing calculation
                setTimeout(() => {
                    if (!this.shown) document.body.classList.remove('push-content');
                }, 350);
            }
        }
    },

    methods: {
        close (e) {
            e.preventDefault();
            e.stopPropagation();
            this.$modalityStore.closeModal({type: 'overlay', name: this.name});
        }
    }
}
</script>
